import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Search, ShoppingBag, User, Menu, X } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { api, fileUrl } from "@/lib/api";
import { brl } from "@/lib/fmt";
import { Logo } from "./Bits";

const NAV = [
  ["Suplementos", "/categoria/suplementos"],
  ["Fitoterápicos", "/categoria/fitoterapicos"],
  ["Chás", "/categoria/chas"],
  ["Kits", "/kits"],
  ["Guia das plantas", "/blog"],
];

function SearchBox({ onDone }) {
  const [q, setQ] = useState("");
  const [sug, setSug] = useState([]);
  const nav = useNavigate();
  useEffect(() => {
    if (q.length < 2) return setSug([]);
    const t = setTimeout(() => api.get("/search/suggest", { params: { q } }).then((r) => setSug(r.data)), 200);
    return () => clearTimeout(t);
  }, [q]);
  const go = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    nav(`/busca?q=${encodeURIComponent(q)}`);
    setSug([]);
    onDone?.();
  };
  return (
    <form onSubmit={go} className="relative w-full" role="search">
      <label htmlFor="busca" className="sr-only">Buscar produtos</label>
      <Search className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-na-ink2" />
      <input id="busca" data-testid="search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar magnésio, camomila..." className="input-na rounded-full py-2.5 pl-10" autoComplete="off" />
      {sug.length > 0 && (
        <div className="absolute left-0 right-0 top-full z-50 mt-2 overflow-hidden rounded-3xl border border-na-line bg-white shadow-xl" data-testid="search-suggestions">
          {sug.map((s) => (
            <Link key={s.slug} to={`/produto/${s.slug}`} onClick={() => { setSug([]); setQ(""); onDone?.(); }} className="flex items-center gap-3 px-4 py-2.5 hover:bg-na-sage2" data-testid={`suggestion-${s.slug}`}>
              <img src={fileUrl(s.imagem)} alt="" className="prod-img h-10 w-10 object-contain" />
              <span className="flex-1 text-sm text-na-ink">{s.nome}</span>
              <span className="text-sm font-semibold">{brl(s.preco)}</span>
            </Link>
          ))}
        </div>
      )}
    </form>
  );
}

export default function Header() {
  const { settings, count, setDrawer } = useStore();
  const [open, setOpen] = useState(false);
  const ref = useRef();
  return (
    <>
      <div className="bg-na-forest px-4 py-2 text-center text-xs font-medium text-white sm:text-sm" data-testid="announcement-bar">
        {settings?.aviso_topo || "Frete grátis nas compras acima de R$ 199 e 5% de desconto no Pix"}
      </div>
      <header ref={ref} className="sticky top-0 z-40 border-b border-na-line bg-na-bg/90 backdrop-blur-xl">
        <div className="container-na flex h-16 items-center gap-4 lg:h-20">
          <button className="lg:hidden" onClick={() => setOpen(!open)} aria-label="Abrir menu" data-testid="mobile-menu-button">
            {open ? <X /> : <Menu />}
          </button>
          <Logo />
          <nav className="ml-6 hidden items-center gap-6 lg:flex" aria-label="Principal">
            {NAV.map(([l, to]) => (
              <NavLink key={to} to={to} data-testid={`nav-${to.split("/").pop()}`} className={({ isActive }) => `text-sm font-medium transition-colors hover:text-na-forest ${isActive ? "text-na-forest" : "text-na-ink2"}`}>
                {l}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto hidden w-72 md:block"><SearchBox /></div>
          <div className="ml-auto flex items-center gap-1 md:ml-2">
            <Link to="/conta" className="rounded-full p-2.5 hover:bg-na-sage2" aria-label="Minha conta" data-testid="account-link"><User className="h-5 w-5" /></Link>
            <button onClick={() => setDrawer(true)} className="relative rounded-full p-2.5 hover:bg-na-sage2" aria-label="Abrir sacola" data-testid="cart-button">
              <ShoppingBag className="h-5 w-5" />
              {count > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-na-acai px-1 text-[11px] font-bold text-white" data-testid="cart-count">{count}</span>}
            </button>
          </div>
        </div>
        {open && (
          <div className="border-t border-na-line bg-white px-4 py-4 lg:hidden" data-testid="mobile-menu">
            <SearchBox onDone={() => setOpen(false)} />
            <nav className="mt-3 flex flex-col">
              {NAV.map(([l, to]) => (
                <Link key={to} to={to} onClick={() => setOpen(false)} className="border-b border-na-line py-3 font-medium">{l}</Link>
              ))}
            </nav>
          </div>
        )}
      </header>
    </>
  );
}
